import React, { FC } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';

import { UIButton } from 'components/ui';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger
} from 'components/ui';

interface Action {
  label: string;
  handler: (data: any) => void;
  icon?: React.ElementType;
  disabled?: boolean;
}

interface ActionCellProps {
  rowData: any;
  actions: Action[];
  menuLabel?: string;
}

const ActionCell: FC<ActionCellProps> = ({ rowData, actions, menuLabel }) => (
  <DropdownMenu>
    <DropdownMenuTrigger asChild>
      <UIButton
        variant="ghost"
        className="p-0 w-[24px] max-w-[24px] h-[24px] flex items-center justify-center"
      >
        <FontAwesomeIcon
          icon="fa-regular fa-ellipsis-vertical"
          className="text-black text-[16px]"
        />
      </UIButton>
    </DropdownMenuTrigger>
    <DropdownMenuContent
      side="left"
      align="start"
      sideOffset={0}
      className="bg-base-popover border-base-border rounded-md w-auto min-w-0"
    >
      {menuLabel && (
        <DropdownMenuLabel className="border-b border-base-muted-foreground">
          {menuLabel}
        </DropdownMenuLabel>
      )}
      {actions.map((action: Action, index: number) => (
        <DropdownMenuItem
          key={index}
          onClick={() => action.handler(rowData)}
          className="text-base-popoverForeground text-p-s hover:bg-base-accent cursor-pointer hover:rounded-md"
          disabled={action.disabled}
        >
          {action.icon && <action.icon className="mr-2" />}
          {action.label}
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  </DropdownMenu>
);

export default ActionCell;
